import { nextTick, onMounted, onUnmounted,updated } from 'vue';

function updateHeight(el, binding) {
  let extraHeight = binding.value.extraHeight || 85;
  let trHeight = binding.value.trHeight || 0;
  
  let tTable = el.getElementsByClassName("ant-table")[0];
  let tHeader = el.getElementsByClassName("ant-table-thead")[0];
  let tHeaderBottom = tHeader ? tHeader.getBoundingClientRect().bottom : 0;
  let tBody = el.getElementsByClassName("ant-table-body")[0];

  let height = `calc(100vh - ${tHeaderBottom + extraHeight}px)`;
  let minHeight;
  let data=(el.getElementsByClassName("ant-table-row")[0])?true:false;
  if(data){
    minHeight = `calc(100vh - ${tHeaderBottom + extraHeight}px  + ${trHeight}px)`;
  }else{
    //64px为分页高度及边距
    minHeight = `calc(100vh - ${tHeaderBottom + extraHeight}px + ${trHeight}px + 64px)`;
  }
  if(tBody){
    nextTick(() => {
      tBody.style.maxHeight = height;
    });
  }
  if(tTable){
    tTable.style.height = minHeight;
    tTable.style.minHeight = minHeight;
  }
  let placeholder = el.getElementsByClassName('ant-table-placeholder')[0];
  if (placeholder) {
    nextTick(() => {
      placeholder.style.height = height;
    });
  }
}

export default {
    mounted(el, binding) {
        updateHeight(el, binding);
    },
    updated(el, binding) {
        updateHeight(el, binding);
        console.log(121)
    },
};
